module.exports = __webpack_public_path__ + "static/media/aws_logo.4d822625.png";